angular.module('bmsApp.merrymaids.job')
	.controller('MMMoveCleanModalCtrl', function ($scope,
												  $modalInstance,
												  MMJobPartSvc,
												  jobPartEvent) {

		function cancel() {
			$modalInstance.dismiss('cancel');
		}

		function init() {
			self.event = jobPartEvent;
		}

		var self = $scope.MMMoveCleanModalCtrl = {
			methods: {
				cancel: cancel,
				init: init
			},
			formValidatorConfig: {
				submitHandler: function () {
					if (self.formValidatorApi.valid()) {
						self.processing = true;
						console.info(jobPartEvent);
						var params = {
							jobPart: {
								id: jobPartEvent.jobPart.id
							},
							start: jobPartEvent.start,
							moveFutureJobParts: self.moveFutureJobParts,
						};
						MMJobPartSvc.moveClean(params)
							.then(function (response) {
								$modalInstance.close({
									success: true
								});
							}, function (errors) {
								self.errors = errors;
							})
							.finally(function () {
								self.processing = false;
							});
					}
				},
				errorPlacement: function (error) {
					error.appendTo('#form-errors');
				},
				errorContainer: '#form-errors'
			},
			formValidatorApi: {},
			event: null,
			processing: false,
			moveFutureJobParts: false,
		};

	});
